// extracted by mini-css-extract-plugin
module.exports = {"actions":"LegendeCreneauToolbar_actions__3v2iv","divider":"LegendeCreneauToolbar_divider__2tKxC"};